<template>
  <div class="advertiseWrapper" v-on:click="goToDetail(adId)">
    <div class="advertiseContent">
      <div class="header">
        <span>{{startDate.substring(2, startDate.length) + ' ~ ' + endDate.substring(2, endDate.length)}}</span>
        <img v-bind:src="stateImg">
      </div>
      <div class="titleInfoDiv">
        <img v-bind:src="titleImgUrl">
        <div class="overlayDiv">
          <span>{{titleText}}</span>
        </div>
      </div>
      <div class="advertiseFooter">
        <div class="totalValueDiv">
          <span>총 도달수</span>
          <span class="totalValue">{{totalExposed + '명'}}</span>
        </div>
        <div class="totalValueDiv">
          <span>총 답변수</span>
          <span class="totalValue">{{totalAnswered + '명'}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    adId: Number,
    state: String,
    startDate: String,
    endDate: String,
    titleImgUrl: String,
    titleText: String,
    totalExposed: Number,
    totalAnswered: Number
  },
  data () {
    return {
      stateImg: ''
    }
  },
  methods: {
    setStateImg: function () {
      if (this.state === 'TEMPORARY') {
        this.stateImg = require('@/assets/img/advertise_temporary_state_icon.png')
      } else if (this.state === 'WAITING') {
        this.stateImg = require('@/assets/img/advertise_waiting_state_icon.png')
      } else if (this.state === 'ON_PROGRESS') {
        this.stateImg = require('@/assets/img/advertise_progressing_state_icon.png')
      } else if (this.state === 'COMPLETED') {
        this.stateImg = require('@/assets/img/advertise_complete_state_icon.png')
      } else if (this.state === 'STOPPED_BY_ADMIN' || this.state === 'STOPPED_INSUFFICIENT_POINTS') {
        this.stateImg = require('@/assets/img/advertise_reported_state_icon.png')
      }
    },
    goToDetail: function () {
      if(this.state === 'TEMPORARY') {
        this.$router.push({ name: 'enroll', params: {state: 'TEMPORARY', adId: this.adId} })
      }else{
        this.$router.push('/board/advertise-info/' + this.adId)
      }
    }
  },
  created: function () {
    this.setStateImg()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.advertiseWrapper{
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: 25%;
}

.advertiseContent {
  cursor: pointer;
  display: flex;
  display: -ms-flexbox;
  flex-wrap : wrap;
  flex-direction: column;
  width: 185px;
  padding: 15px;
  margin-bottom: 16px;
  border-radius: 8px;
  border: rgb(207,207,207) 1px solid;
}

.header {
  display: flex;
  display: -ms-flexbox;
  justify-content: space-between;
  align-items: center;
  font-size: 10px;
  margin-bottom: 10px;
}

.header > img{
  width: 48px;
  height: 24px;
}

.titleInfoDiv{
  position: relative;
  height: 128px;
  width: 100%;
}

.titleInfoDiv > img{
  width: 100%;
  height: 100%;
}

.titleInfoDiv > .overlayDiv{
  display:table;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  font-size: 28px;
  text-align: center;
  color: white;
  background-color: rgba(0, 0, 0, 0.3);
}

.overlayDiv > span{
  display: table-cell;
  vertical-align: middle;
}

.advertiseFooter{
  display: flex;
  display: -ms-flexbox;
  padding: 0;
  margin-top: 10px;
}

.totalValueDiv{
  display: flex;
  display: -ms-flexbox;
  flex-direction: column;
  justify-content: center;
  font-size: 10px;
  flex: 0.5
}

.totalValueDiv > .totalValue{
  padding: 5px 0;
  font-size: 13px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/board/elements/advertise.vue